import React, { useEffect } from "react";
import { getAllUserTypesInfo } from "../../../../redux/actions/user";
import { useDispatch, useSelector } from "react-redux";

function Sidebar2(props) {
  const { allusertypesinfo } = useSelector((state) => state.user);
  const { customerOrCollaboratorList } = useSelector(
    (state) => state.collaboratorOrCustomer
  );
  const { userList } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getAllUserTypesInfo((res) => {}));
  }, [dispatch, customerOrCollaboratorList, userList]);
  return (
    <div className="w-full no-scrollbar md:w-[20%] bg-white md:overflow-x-scroll md:border-b md:space-y-3 px-5">
      <p className="block font-semibold text-sm text-slate-800 mt-3">Users</p>

      <ul className="w-full overflow-x-scroll space-x-2 sm:space-x-0 md:overflow-x-hidden flex mt-5 mr-3 md:block md:mt-0">
        <div className="border-b border-b-[#D9D9D9] pb-2">
          <div className=" flex round-full justify-between bg-[--bg-color-50] p-1">
            <span className="text-sm">All Users</span>
            <span className="text-sm">
              {allusertypesinfo?.users +
                allusertypesinfo?.super_admins +
                allusertypesinfo?.admins +
                allusertypesinfo?.collaborators +
                allusertypesinfo?.customers}
            </span>
          </div>
        </div>
        <div className="flex justify-between pt-2 px-1">
          <span className="text-sm ">Super Admin</span>
          <span className="text-sm pl-4">{allusertypesinfo?.super_admins}</span>
        </div>
        <div className="flex justify-between pt-2 px-1">
          <span className="text-sm">Admin</span>
          <span className="text-sm pl-4">{allusertypesinfo?.admins}</span>
        </div>
        <div className="flex justify-between pt-2 px-1">
          <span className="text-sm">Regular User</span>
          <span className="text-sm pl-4">{allusertypesinfo?.users}</span>
        </div>
        <div className="flex justify-between pt-2 px-1">
          <span className="text-sm">Collaborator</span>
          <span className="text-sm pl-4">
            {allusertypesinfo?.collaborators}
          </span>
        </div>
        <div className="flex justify-between pt-2 px-1">
          <span className="text-sm">Customer</span>
          <span className="text-sm pl-4">{allusertypesinfo?.customers}</span>
        </div>
      </ul>
    </div>
  );
}

export default Sidebar2;
